// extracted by mini-css-extract-plugin
export var closeButton = "videoModal-module--closeButton--seynP";
export var video = "videoModal-module--video--w27aL";